<footer class="footer"  id="ple-footer">
    <div class="footer-padding"></div>
    <div class="footer-content">
      <div class="company-padding">
        {{copyright}}
      </div>
      <span class="fill-spacer"></span>
      <div select="[footer-links]">
        <ng-content></ng-content>
      </div>
    </div>
</footer>
